// Errors - component > errors
export const FORM_404 = {
  continueShopping: 'Continue shopping',
  looksLike:
    'Looks like the page you are looking for is temporarily unavailable.',
  notFoundSeriously: '##STATUSCODE## - seriously, so embarrassing.',
};
